import {
    AccessLevel,
    CorporationResponse,
    FileParameter,
    GeneralDetailError,
    IPictureFileMetadataResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { UseMutateFunction } from '@tanstack/react-query';
import { SelectOption } from 'components/forms/Select';
import { FileUpload } from 'pages/Settings/FileLibrary/shared';
import { isFileAJpeg, normalizeImageFileRotation } from 'utils/file';

export const accessLevelOptions = Object.values(AccessLevel).map<SelectOption>(
    (value) => ({
        title: value.toString(),
        value: value.toString(),
    })
);

export const onUploadInputChange = async (
    fileInput: HTMLInputElement | null,
    uploadIcon: UseMutateFunction<CorporationResponse, unknown, FileParameter, unknown>,
    uploadFile?: UseMutateFunction<
        IPictureFileMetadataResponse,
        Error | GeneralDetailError,
        FileUpload,
        unknown
    >
) => {
    if (fileInput) {
        const { files } = fileInput;
        const fileData = Array.from(files as ArrayLike<File>)[0];

        if (isFileAJpeg(fileData)) {
            const normalizedFile = await normalizeImageFileRotation(fileData);
            uploadIcon({
                data: normalizedFile,
                fileName: fileData.name,
            });
            uploadFile?.({ data: normalizedFile, name: fileData.name });
        } else {
            uploadIcon({
                data: fileData,
                fileName: fileData.name,
            });
            uploadFile?.({ data: fileData, name: fileData.name });
        }
    }
};
